(function (ws) {
    'use strict';
    ws.views.quoteProductTable = ws.views.simpleTable.extend({

        SEARCH_URL_PRODUCT_TABLE: globals.path.api.quoting.addProductCategories,

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#qut-quotes-table');
            this.$form = this.$('.cpt-product-table-form');
            this.rowTemplate = this.$('#cpt-table-row');
            this.$selectAllContainer = this.$('.select-all-container');
            this.$selectAllCheckbox = this.$('.qut-select-all');
            this.paginateUrl = globals.path.api.quoting.addProductCategories;
            ws.views.simpleTable.prototype.initialize.call(this);
            this.searchUrl = globals.path.api.quoting.addProductCategories;
            this.collection = new ws.collections.addTableProductsCollection();
            this.collection.model = ws.models.addTableProductsModel;

            //dropdowns
            this.eventAgg.on('qut-FetchAddProductDropdowns', this.searchFilter.bind(this));
            this.dropdownsContainer = this.$('.tbl-simple-filters');

            this.$table.hide();
            this.$selectAllContainer.hide();
            this.$errors = {
                emptyFields: this.$('.qap-bom-empty-fields'),
                noResults: this.$('.qap-bom-no-results')
            };
            this.tpl = $('#quote-required-products').html();

            //for spinner
            this.$saveButton = this.$('.qap-btn-add');
            this.$emtpyTableCopy.hide();

            this.$cartTableErrorsContainer = $('.qap-prod-validation-error-messages');
            this.$inValidAwsProductsErr = $('.qap-prod-validation-error-messages  .inValidAwsProducts');
            this.$catalogErrorsContainer = $('.qap-catalogProd-validation-error-messages');
            this.$sapValidationErrors = this.$('.qap-sap-validation-error');
            this.$cloudValidationErrors = this.$('.qap-cloud-validation-error');
            this.availabilityTemplate = this.$('#qut-prod-search-tooltip');
            this.$tblPagination = this.$('.tbl-pagination');

            $(document).on('focusout', '.catalog-input-search', (e) => {
                this.searchFilter(e);
            });
        },

        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'submit .cpt-product-table-form': 'addProducts',
            'click .qut-select-all': 'selectAll',
            'change .checkbox input': 'updateSelectAlLState',
            'change .cpt-filter-dropdown': 'searchFilter',
            'mouseover .qut-qty-tooltip': 'renderAvailabilityData',
            'touchstart .qut-qty-tooltip': 'renderAvailabilityData',
            'mouseout .qut-qty-tooltip': 'hideAvailabilityTooltip',
            'click tbody > tr': 'multipleRowSelect',
            'change input[name="selectedProduct"]': 'toggleAddButtonState',
            'change select#tbl-simple-page-size': 'filterSizeResults'
        }),

        /**
         * Deselect all ros
         * @param {element} tr
         */
        deselectAllrows: function(tr) {
            _.each(this.$table.find('tr'), function(tr) {
                this.toggleRow(tr, false, false);
            }.bind(this));

            this.toggleAddButtonState();
        },

        /**
         * Toggle if row is selected
         * @param {element} tr
         * @param {boolean} toggle
         */
        toggleRow: function(tr, toggle, emmitEvent) {
            var $checkbox = $(tr).find('input:checkbox');
            emmitEvent = (emmitEvent !== undefined) ? emmitEvent : true;

            $(tr).toggleClass('selected', toggle);
            $checkbox.prop('checked', toggle);
            if (emmitEvent) {
                $checkbox.trigger('change');
            }
        },

        /**
         * Allow selecting of multiple rows
         * @param {Object} e
         */
        multipleRowSelect: function(e) {
            if (!$(e.target).is('label') && !$(e.target).hasClass('control')) {
                var tr = e.currentTarget;

                if (!e.shiftKey) {
                    this.previousSelectedRow = tr;
                    this.toggleRow(tr, !$(tr).hasClass('selected'));
                } else {
                    this.previousSelectedRow = this.$table.find('tr.selected')[0];
                    this.deselectAllrows();

                    var firstRow = Math.min(this.previousSelectedRow.rowIndex, tr.rowIndex);
                    var lastRow = Math.max(this.previousSelectedRow.rowIndex, tr.rowIndex);

                    for (var i = firstRow; i <= lastRow; i++) {
                        //text in DataTables gets highlighted by default, so need to deselect it
                        if (window.getSelection) {
                            window.getSelection().removeAllRanges();
                        }

                        this.toggleRow($(this.$table[0].rows[i]), true);
                    }
                }
            }
        },

        callFetchQuoteFieldDetailsForModal: function (payload) {
            $.ajax({
                url: globals.path.api.quoting.fetchDealIdVendors + '?salesOrg=' + $('#sales-org-input').val() + '&' + CSRF,
                type: 'POST',
                success: function (res) {
                    let emptyOption = `<option value='' selected='selected'>--Please Select--</option>`;
                    window.vendorHintJson = {};
                    if (res) {
                        let html = '';
                        res.forEach(function (vendor) {
                            window.vendorHintJson[vendor.code] = vendor.hint;
                            html += `<option value='${vendor.code}'>${vendor.name}</option>`;
                        });

                        $('.select-vendor-ref-no').append(emptyOption + html);
                    }
                }.bind(this),

                error: function (xht, textStatus, ex) {
                    console.log(textStatus);
                }
            });
        },

        /**
         * Trigger a filter request after any of the dropdowns has changed
         * @param {Object} ev
         */
        filterSizeResults: function (ev) {
            this.searchFilter(this.searchUrl, {
                key: ev.currentTarget.name,
                value: ev.currentTarget.value
            });
        },

        /**
         * A helper to hide all errors in the view
         */
        hideErrors: function () {
            this.$error.find('.qap-add-error').hide();
            this.$sapValidationErrors.hide();
            this.$apiError.hide();
        },

        searchFilter: function (e, page) {
            let target = e ? e.currentTarget.name : '';
            if (target === 'catalog') {
                $('.cpt-filter-vendor').val('');
                $('.cpt-filter-category').val('');
            } else if (['vendor', 'category'].includes(target)) {
                $('.catalog-input-search').val('');
            }

            this.hideGenericErrors();
            this.$selectAllContainer.hide();
            this.model.reset();
            this.request = {
                quoteNumber: this.getQuoteId(),
                productCode: $('.catalog-input-search').val(),
                salesOrg: $('#sales-org-input').val() || $('#salesOrg').val(),
                vendorCode: $('.cpt-filter-vendor').val(),
                selectedCategory: $('.cpt-filter-category').val(),
                pageSize: $('.comp-product-table #tbl-simple-page-size').val(),
                currentPage: page ? page : 0,
                sortType: this.sortColumn ? `${this.sortColumn}-${this.sortCode}` : ''
            };

            this.extraParams = this.request;
            this.model.url = globals.path.api.quoting.addProductCategories;
            this.paginateUrl = globals.path.api.quoting.addProductCategories;
            this.searchUrl = globals.path.api.quoting.addProductCategories;
            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();
            this.model.fetch({
                type: 'POST',
                data: JSON.stringify(this.request),
                contentType: 'application/json',
                processData: false
            }).done(function (response) {
                this.$tableSpinner.hide();
                this.$saveButton.prop('disabled', true);
                if (response.browseCategoryData && response.browseCategoryData.vendor) {
                    let vendorHtml = '<option value="">--Please Select--</option>';
                    response.browseCategoryData.vendor.forEach((item) => {
                        vendorHtml += `<option value="${item.code}" ${item.selected ? ' selected' : ''}>${item.name}</option>`;
                    });

                    $('.cpt-filter-vendor').empty().append(vendorHtml);
                }

                if (response.browseCategoryData && response.browseCategoryData.category) {
                    let categoryrHtml = '<option value="">--Please Select--</option>';
                    response.browseCategoryData.category.forEach((item) => {
                        categoryrHtml += `<option value="${item.code}" ${item.selected ? ' selected' : ''}>${item.name}</option>`;
                    });

                    $('.cpt-filter-category').empty().append(categoryrHtml);
                }

                if (response.productData.data) {
                    this.$tblPagination.show();
                    this.$table.show();
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    this.renderRows(response.productData.data);
                    this.$table.on('responsive-display.dt', function (e, datatable, row, showHide, update) {
                        var rowNode = row.node();
                        var tooltips = $(rowNode).next().find('[data-view="tooltipModal"]');
                        if (showHide) {
                            _.each(tooltips, function ($el) {
                                new ws.views.tooltipModal({
                                    el: $el
                                });
                            });
                        }
                    });

                    if (response.productData.data.length > 0) {
                        this.$selectAllContainer.show();
                    }

                    this.calculateShowingPerPage(response.productData.paginationData);
                    this.calculateShowing(response.productData.paginationData);
                    this.calculatePagination(response.productData.paginationData);
                    this.eventAgg.trigger('ws.views.quoteProductTable:filters:fetched');
                    this.$pagination.addClass('search');
                } else {
                    this.$pagination.hide();
                    $('.tbl-simple-page').hide();
                    $('.tbl-simple-showing').hide();
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    this.$table.hide();
                    this.$emtpyTableCopy.show();
                }
            }.bind(this)).fail(function () {
                console.log('Error occured');
            }.bind(this));

            if (!window.vendorHintJson && $('#quf-enter-id').is(':visible')) {
                this.callFetchQuoteFieldDetailsForModal();
            }
        },

        /**
         * Calculate if show per page dropdown show or hide
         */
        calculateShowingPerPage: function (paginationData) {
            if (paginationData.totalNumberOfResults > 25) {
                $('.tbl-simple-page').show();
            } else {
                $('.tbl-simple-page').hide();
            }
        },

        /**
         * Toggle select all products
         * @param {Object} ev - Event object
         */
        selectAll: function (ev) {
            var isChecked = ev.currentTarget.checked;

            _.each(this.$table.find('tr'), function(tr) {
                this.toggleRow(tr, isChecked, false);
            }.bind(this));

            this.toggleAddButtonState();
        },

        /**
         * Update the state of the select all checkbox based on the checkboxes of the table.
         */
        updateSelectAlLState: function () {
            var checkboxes = this.$table.find('.checkbox').find('input');
            var allCheckboxesAreSelected = _.every(checkboxes, function (checkbox) {
                return $(checkbox).prop('checked');
            });

            this.$selectAllCheckbox.prop('checked', allCheckboxesAreSelected);
        },

        /**
         * Render rows override to cater for availability
         */
        renderRows: function (result) {
            var options;
            var _this = this;

            _.each(result, function (row) {
                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
                _.each(tableRow.$('[data-view="tooltipModal"]'), function ($el) {
                    new ws.views.tooltipModal({
                        el: $el
                    });
                });
            });

            this.initializeDataTable(true);
            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Add selected products to quote table
         * @method addProduct
         * @param {Event} ev - Event object
         */
        addProducts: function (ev) {
            var $modal = this.$el.closest('.modal-container');
            this.hideErrors();
            this.$errors.emptyFields.hide();

            ev.preventDefault();

            this.$('[name=selectedProduct]:checked').each(function (index, item) {
                this.collection.add({
                    partsNo: item.value
                });
            }.bind(this));

            if (this.collection.length > 0) {

                //enable Spinner
                this.$saveButton.addClass('spinner-before no-padding').prop('disabled', true);

                this.collection.save().done(function (data) {

                    //disable spinner
                    this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                    this.collection.reset();
                    if (data.awsCppoRecalculationRequired && data.invalidAwsProducts) {
                        $('.recalculate-aws-button').removeClass('hidden');
                        this.$inValidAwsProductsErr.find('.inValidAwsProductsItems').html(data.invalidAwsProducts).show().removeClass('hide');
                        this.$inValidAwsProductsErr.show().removeClass('hide');
                    } else if (data.invalidAwsProducts) {
                        $('.qap-invalid-products-bom').text(data.inValidAwsProducts);
                        $('.inValidAwsProducts-bom').removeClass('hide').show();
                    } else {
                        this.$inValidAwsProductsErr.hide().addClass('hide');
                        $('.inValidAwsProducts-bom').hide().addClass('hide');
                    }

                    if (!data.data) {
                        if (data.restrictProductsToQuoteOrder) {
                            $('.saudiErrorMsg').html(data.error).removeClass('hide').show();
                        }

                        this.eventAgg.trigger('showSAPExceptions', data, this.$catalogErrorsContainer);
                    } else {
                        this.eventAgg.trigger('refreshQuoteProductCart');
                        this.eventAgg.trigger('addProductByOverlay');
                        this.$saveButton.prop('disabled', true);
                        this.eventAgg.trigger($modal.prop('id') + 'close');
                        this.eventAgg.trigger('showSAPExceptions', data, this.$cartTableErrorsContainer);
                        this.eventAgg.trigger('qutRenderRequiredProducts', data.mandatoryAssociatedProductsForm);
                    }

                }.bind(this)).fail(function() {
                    this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                    this.$apiError.show();
                }.bind(this));
            } else {
                this.$errors.emptyFields.show();
            }
        },

        /**
         * Render tooltip data
         * @param {Object} e
         */
        renderAvailabilityData: function (e) {
            var $elm = $(e.target);
            var prodId = $elm.data('id');
            var offsetY = 180;
            var offsetX = 220;
            var quoteId = this.getQuoteId();
            var availabilityData = new ws.models.detailProdAvailability({
                id: prodId,
                quoteId: quoteId
            });

            this.availabilityTooltipView = new ws.views.quoteTableGenericTooltip({
                model: availabilityData,
                tooltipClass: 'qut-availability-tooltip availability-tooltip',
                templateId: '#qut-availability-tooltip',
                isIntangible: ''
            });

            this.availabilityTooltipView.appendAndRenderTooltip(e.clientY - offsetY, e.clientX - offsetX, this.$form);
        },

        /**
         * Getting the quoteId from the url
         */
        getQuoteId: function() {
            let url = window.location.pathname.split('/');
            return url[url.length - 1];
        },

        /**
         * hides availability tooltip
         */
        hideAvailabilityTooltip: function() {
            this.availabilityTooltipView.closeTooltipModal();
        },

        /**
         * Enable/disable add button based on the amount of products selected.
         */
        toggleAddButtonState: function () {
            var $selectedCheckboxes = this.$('input[name="selectedProduct"]:checked');

            this.$saveButton.attr('disabled', $selectedCheckboxes.length === 0);
        }

    });

})(westcon);

